export default __webpack_public_path__ + "static/media/cooking.d97ce59c.svg";